(function () {
  'use strict';

  angular
      .module('tfc.retailer.ConsumerSampling')
      .directive('tfcAgeRangeChart', tfcAgeRangeChart)
      .controller('tfcAgeRangeChartCtrl',tfcAgeRangeChartCtrl);

  function tfcAgeRangeChart(){
    return {
      restrict: 'E',
      templateUrl : 'ConsumerSampling/AgeRangeChart.tmpl.html',
      scope: {
        samplingAgeRangeObj: '='
      },
      controller : 'tfcAgeRangeChartCtrl as vm',
      bindToController : true
    }
  }

  // @ngInject
  function tfcAgeRangeChartCtrl(ChartService, SplitRange){
    var vm = this;

    var options = {
      horizontal : false,
      hideBarLabels : true,
      dashedLabelBoxes : false,
      isDashedLabelBoxesExist: false,
      labelSize: 80,
      showFirstLastLabels: true
    };

    function constructSamplingChart(data){
      var samplingChart = {};
      if(data.length){
        samplingChart = ChartService.getBarChartWithLabel(_.sortBy(data, 'label'));
        if(!vm.samplingAgeRange || !vm.samplingAgeRange.viewChartDetails){
          samplingChart.data = _.dropRight(samplingChart.data);
          samplingChart.data[0].label = _.head(samplingChart.data).label.split(SplitRange.regex)[0];
          samplingChart.data[samplingChart.data.length-1].label = _.last(samplingChart.data).label.split(SplitRange.regex)[1];
        }
      }
      return samplingChart;
    }

    function getSamplingAgeRangeObj(sampleObj, options){
      return {
        samplingChart: constructSamplingChart(sampleObj.samplingPercent),
        viewChartDetails: false,
        options: _.cloneDeep(options)
      }
    }

    vm.samplingAgeRange = getSamplingAgeRangeObj(vm.samplingAgeRangeObj, options);

    vm.toggleChartSummaryView = function () {
      vm.samplingAgeRange.viewChartDetails = !vm.samplingAgeRange.viewChartDetails;
      vm.samplingAgeRange.samplingChart = constructSamplingChart(vm.samplingAgeRangeObj.samplingPercent);
      vm.samplingAgeRange.options = _.assign(options, {horizontal: vm.samplingAgeRange.viewChartDetails,
        showFirstLastLabels: !vm.samplingAgeRange.viewChartDetails});
    }

  }

})();